import React, { useState } from "react";
import { api } from "../api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Skickar...");
    try {
      await api.post("/auth/forgot", { email });
      setStatus("Om e-posten finns registrerad har ett återställningsmail skickats.");
    } catch {
      setStatus("Kunde inte skicka återställningsmail.");
    }
  };

  return (
    <div className="container mt-3" style={{ maxWidth: 420 }}>
      <h3 className="mb-3">Glömt lösenord</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Din e-post</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button className="btn btn-primary w-100">Skicka återställningslänk</button>
      </form>
      {status && <div className="alert alert-info mt-3">{status}</div>}
    </div>
  );
}
